export const TILE_COUNT = 12;
export const GRID_SIZE = 4;
export const BOARD_SIZE = 320;